/**
 * Get the current environment variable, pulled at run time
 * @param name string containing the environment variable name
 */
export function getEnvVar(name: string): string {
  try {
    const storedEnv = localStorage.getItem('env');

    // Workaround for legacy env vars
    if (name === 'REACT_APP_API_BASE_URL' && !!process.env.REACT_APP_API_BASE_URL) {
      return `${process.env.REACT_APP_API_BASE_URL}`;
    }
    if (name === 'REACT_APP_FIREBASE_API_KEY' && !!process.env.REACT_APP_FIREBASE_API_KEY) {
      return `${process.env.REACT_APP_FIREBASE_API_KEY}`;
    }
    if (name === 'REACT_APP_AUTH_DOMAIN' && !!process.env.REACT_APP_AUTH_DOMAIN) {
      return `${process.env.REACT_APP_AUTH_DOMAIN}`;
    }
    if (name === 'REACT_APP_DATABASE_URL' && !!process.env.REACT_APP_DATABASE_URL) {
      return `${process.env.REACT_APP_DATABASE_URL}`;
    }
    if (name === 'REACT_APP_PROJECT_ID' && !!process.env.REACT_APP_PROJECT_ID) {
      return `${process.env.REACT_APP_PROJECT_ID}`;
    }
    if (name === 'REACT_APP_STORAGE_BUCKET' && !!process.env.REACT_APP_STORAGE_BUCKET) {
      return `${process.env.REACT_APP_STORAGE_BUCKET}`;
    }
    if (name === 'REACT_APP_MESSAGING_SENDER_ID' && !!process.env.REACT_APP_MESSAGING_SENDER_ID) {
      return `${process.env.REACT_APP_MESSAGING_SENDER_ID}`;
    }
    if (name === 'REACT_APP_APP_ID' && !!process.env.REACT_APP_APP_ID) {
      return `${process.env.REACT_APP_APP_ID}`;
    }

    if (storedEnv) {
      const parsedEnv = JSON.parse(storedEnv);
      const env_var = parsedEnv[name];

      if (env_var) {
        return `${env_var}`;
      }
    }

    const xhr = new XMLHttpRequest();
    xhr.open('GET', '/public_env', false);
    xhr.send();

    if (xhr.status === 200) {
      const env = JSON.parse(xhr.responseText);
      localStorage.setItem('env', JSON.stringify(env));

      const env_var = env[name];

      if (env_var) {
        return `${env_var}`;
      }
      throw new Error('Desired value not found in the fetched environment data.');
    } else {
      console.error('Error fetching the file:', xhr.statusText);
    }
  } catch (e) {
    console.error('Failed to pull environment variable');
  }

  return '';
}
